
class Debug {
    static enabled = false;
    static superEnabled = false;
}

(window as any).Debug = Debug;

export { Debug }